import useHttpClient from "./http/useHttpClient";
import {setEvent, setStadium} from "../store/actions";
import {useDispatch} from "react-redux";
import {DoorModel} from "../Models/DoorModel";

export const useGetEvent = (onEventError?: () => void, onApiError?: () => void): (stadium: string | undefined, onSuccess?: (res: DoorModel[]) => void) => void => {
    const dispatch = useDispatch()
    const {auth, getEvent} = useHttpClient()
    return (stadium: string | undefined, onSuccess?: (res: DoorModel[]) => void) => {
        const body = {
            api_key: "qh6A9UkQ4rBL27493s86jPRCdhx36Y6W2NZT4eeh38Zy84Vj5iHpvwxMN2YMcf2Q",
            bart_key: "J3s2KekzVQCCy6U8rvXBB8g45L53Xfj6eG998KfeWc7uBZu4y42u6jWXQ3Njf753",
            stadium_reference: stadium
        }
        void auth(body)
            .then(res => {
                const jwt = res.token
                localStorage.setItem("topivotoken", jwt)
                dispatch(setStadium(res.stadium))
                getEvent()
                    .then(event => {
                        dispatch(setEvent(event))
                        onSuccess && onSuccess(res.stadium.doors)
                    })
                    .catch(onEventError)
            }).catch(onApiError)
    }
}
